<template>
  <div>
    <div>
      <strong>{{ $t('component.proj.feeSumCard.cardTitle') }}</strong>
    </div>
    <Divider />

    <Content class="cust-content">
      <Row class="content-info" id="printDomFeeTable">
        <Table ref="feeTable" :row-class-name="rowClassName"
               :columns="transColumns" :data="tableData" border width="500"
               show-summary :summary-method="handleSummary"
               :loading="isListLoading">
          <template slot-scope="{ row, index }" slot="number">
<!--            <span>{{ (row.level===2?"&nbsp;&nbsp;&nbsp;":(row.level===3?"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;":"")) + row.number }}</span>-->
            <span>{{ row.number }}</span>
          </template>

          <template slot-scope="{ row, index }" slot="feeName">
            <span>{{ row.feeName }}</span>
          </template>

          <template slot-scope="{ row, index }" slot="feeAmt">
            <span>{{ formatThousandthNumber(row.feeAmt) }}</span>
          </template>
        </Table>
      </Row>
      <br />
      <Row class="content-info">
        <Button type="primary"
                @click="printPage"
                style="min-width: 87px;">
          {{ $t('common.toolBar.printBtn') }}
        </Button>
        <Button type="primary"
                @click="exportData"
                style="min-width: 87px; margin-left: 24px;">
          {{ $t('common.toolBar.exportBtn') }}
        </Button>
      </Row>
    </Content>
  </div>
</template>

<script>
import * as Utils from '@/utils'

export default {
  props: {
    feeNameDDList: {
      type: Array,
      require: true,
      default: () => {
        return []
      }
    },
    transList: {
      type: Array,
      require: true,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      // feeMap: {},
      isListLoading: false,
      tableData: [],
      transColumns: [
        {
          title: this.$t('component.proj.feeSumCard.number'),
          slot: 'number',
          // key: 'number',
          align: 'left',
          // fixed: 'left',
          width: 80
        },
        {
          title: this.$t('component.proj.feeSumCard.feeName'),
          slot: 'feeName',
          key: 'feeName',
          align: 'left',
          // fixed: 'left',
          width: 250
        },
        {
          title: this.$t('component.proj.feeSumCard.feeAmt'),
          slot: 'feeAmt',
          key: 'feeAmt',
          align: 'right'
          // ,
          // width: 140
        }
      ]
    }
  },
  computed: {
  },
  methods: {
    rowClassName(row, index) {
      if (row.indEndNode === 'N') {
        return 'table-column-row-disabled'
      }

      return ''
    },
    handleSummary({ columns, data }) {
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (!key) {
          sums[key] = {
            key,
            value: ''
          }
          return
        }
        if (key === 'feeName') {
          sums[key] = {
            key,
            value: this.$t('common.commonVar.total')
          }
          return
        }
        // debugger
        const values = data.map(item => Number(item[key]))
        // let values = []
        // if (key === 'balAmt') {
        //   values = values.concat(data.map(item => Number(item['inAmt'])))
        //   values = values.concat(data.map(item => Number(item['outAmt']) * -1))
        // } else {
        //   values = data.map(item => Number(item[key]))
        // }
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[key] = {
            key,
            value: this.formatThousandthNumber(v)
          }
        } else {
          sums[key] = {
            key,
            value: 'N/A'
          }
        }
      })

      return sums
    },
    printPage() {
      // #调试用, 将printFrame显示出来, 便于查看需要打印的内容
      // document.getElementById('printFrame').style.display = 'block'
      // document.getElementById('printFrame').style.height = '50%'
      // document.getElementById('printFrame').style.width = '100%'
      // document.getElementById('printFrame').style.top = '0'
      // document.getElementById('printFrame').style['z-index'] = '10000'
      // document.getElementById('printFrame').style['background-color'] = '#fff'
      let printWindow = document.getElementById('printFrame').contentWindow
      printWindow.document.body.innerHTML = '' // 清楚printFrame的内容
      let node = document.getElementById('printDomFeeTable').cloneNode(true) // 将需要打印的内容拷贝到printFrame中
      printWindow.document.body.appendChild(node)

      // 处理浮动table，将table的data和summary部分都放到head所在的table中去
      let transTableList = printWindow.document.getElementById('printDomFeeTable').getElementsByTagName('table')
      transTableList[0].border = '1'
      transTableList[0].appendChild(transTableList[1].getElementsByTagName('tbody')[0])
      transTableList[0].appendChild(transTableList[2].getElementsByTagName('tbody')[0])

      printWindow.print()
    },
    exportData() {
      this.$refs.feeTable.exportCsv({
        filename: this.$t('component.proj.feeSumCard.cardTitle')
      })
    },
    formatThousandthNumber: Utils.formatThousandthNumber,
    END_METHODS() {}
  },
  async mounted() {
    // debugger
    // const feeMap = {}
    // console.log(this.feeNameDDList)
    let feeMap = {}
    for (let i = 0; i < this.transList.length; i++) {
      let trans = this.transList[i]
      let feeAmt = feeMap[trans.feeId] ? feeMap[trans.feeId] : 0
      if (trans.feeId && (trans.reimbOutputSettlAmt || trans.reimbOfficialSettlAmt)) {
        feeMap[trans.feeId] = feeAmt + trans.reimbOutputSettlAmt + trans.reimbOfficialSettlAmt
      }
    }

    this.tableData = []
    for (let i = 0; i < this.feeNameDDList.length; i++) {
      let fee = {...this.feeNameDDList[i]}
      fee.feeAmt = feeMap[fee.feeId] || 0
      this.tableData.push(fee)
    }
  }
}
</script>
<style>
.table-column-row-disabled td {
  color: #c5c8ce;
}
</style>



// WEBPACK FOOTER //
// src/components/proj/FeeSumCard.vue